import { render, staticRenderFns } from "./PitchButton.vue?vue&type=template&id=3d92f194"
import script from "./PitchButton.vue?vue&type=script&lang=js"
export * from "./PitchButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports